<div
  class="flex flex-col items-center justify-center w-[30rem] h-[15rem] mx-auto gap-lg mb-2xl">
  <lib-nothing-here-icon [iconClass]="'w-8xl h-8xl'" />

  <div class="flex flex-col items-center gap-sm text-center">
    <p class="text-xl font-semibold text-neutral-900 font-medium">
      {{
        (retryCount() > 1 ? errorSecondTitleKey() : errorTitleKey()) | transloco
      }}
    </p>
    <p class="text-neutral-500 text-sm font-medium max-w-[25rem]">
      {{
        (retryCount() > 1 ? errorSecondDescriptionKey() : errorDescriptionKey())
          | transloco
      }}
    </p>
  </div>

  <button
    type="button"
    class="flex items-center justify-center w-[10rem] h-5xl px-lg py-sm gap-md bg-primary-500 rounded-md text-white font-medium cursor-pointer border-none hover:bg-primary-600 transition-colors"
    (click)="onRetry()">
    <lib-refresh-icon [iconClass]="'w-xl h-xl'" />
    {{ retryButtonKey() | transloco }}
  </button>
</div>
